import { authenticatedFetch } from '../../../api/utils/request';

export default async function getAds(setErrorMessage) {
    const onError = () => setErrorMessage('No se pueden obtener anuncios');
    return await authenticatedFetch('/ads/all', onError);
}
